<script>
	import Helmet from './Helmet.svelte';
	import Layout from './Layout.svelte';

	import REST from './RESTClass.js';
	import Loader from './Components/Loader/Loader.svelte';

	import Header from './Sections/Header.svelte';
	import Calendar from './Sections/Calendar.svelte';
	import Gospel from './Sections/Gospel.svelte';
	import News from './Sections/News.svelte';
	import Movies from './Sections/Movies.svelte';

    let fetched = false;
    const API = new REST();

	API.getStatus()
        .then(status => setTimeout(() => {
			fetched = status;
		}, 350));

	API.getPost(3108)
		.then(data => console.log(data))
</script>

<Helmet 
	favicon="assets/logo_min.png"
	title="Duszpasterstwo Artystów Archidiecezji Krakowskiej" 
/>

<Loader visible={!fetched} />

<Layout>
	<Header />
	<Gospel />
	<Calendar />
	<News
		source={{
			hook: 'artists',
			title: 'Z życia artystów'
		}}
	/>
	<Movies />
	<News
		source={{
			hook: 'church',
			title: 'Z życia Świętego Krzyża'
		}}
	/>
</Layout>